import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { CodeReviewArtifactModel } from 'src/app/Models/code-review-artifact-model';
import { CodeReviewCommentModel } from 'src/app/Models/code-review-comment-model';
import { CodeReviewModel } from 'src/app/Models/code-review-model';
import { CodeReviewerModel } from 'src/app/Models/code-reviewer-model';
import { CodeReviewService } from 'src/app/Services/code-review.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { ProjectService } from 'src/app/Services/project.service';
import { SharedService } from 'src/app/Services/shared.service';
import { UserService } from 'src/app/Services/user.service';

@Component({
  selector: 'ze-add-code-review',
  templateUrl: './add-code-review.component.html',
  styleUrls: ['./add-code-review.component.scss']
})
export class AddCodeReviewComponent implements OnInit {

  codeReviewForm: FormGroup;
  codeReviewModel: CodeReviewModel;
  artifactTypes: string[] = ['suite', 'feature', 'scenario', 'step'];
  artifactsData: CodeReviewArtifactModel[] = [];
  artifactNameOptions;
  reportArtifactNameOptions = [];
  allReportsData = [];
  artifactReports = [];
  reviewerOptions;
  projectId: string;
  isArtifactProvided: boolean = false;

  constructor(private dialogRef: MatDialogRef<AddCodeReviewComponent>,
    private projectService: ProjectService,
    private userService: UserService,
    private notifyService: NotifyService,
    private codeReviewService: CodeReviewService,
    private sharedService: SharedService, 
    @Inject(MAT_DIALOG_DATA) private data: any,
    private formBuilder: FormBuilder,) { }

  ngOnInit() {
    this.sharedService.loaderHide.emit(true);
    this.projectId = localStorage.getItem("projectId");
    this.codeReviewForm = this.buildForm();
    this.codeReviewForm.get('title').markAsTouched();
    this.codeReviewForm.get('artifact').markAsTouched();
    if(this.data['artifact'] != undefined && this.data['artifact'] != null) {
      this.isArtifactProvided = true;
      this.artifactsData = [this.data["artifact"]];
      this.artifactNameOptions = this.artifactsData;
      this.codeReviewForm.controls.artifactType.setValue(this.data["artifact"].artifactType);
      this.codeReviewForm.controls.artifact.setValue(this.artifactNameOptions[0]);
      this.getReviewers(true);
    } else {
      this.projectService.getArtifactsByProjectId(this.projectId).subscribe(data => {
        if (data && data["data"] && data["data"]["artifacts"]) {
          this.artifactsData = data["data"]["artifacts"];
          this.artifactNameOptions = this.artifactsData.filter(artifact => artifact.artifactType == "suite");
          if (this.artifactNameOptions.length > 0) {
            this.codeReviewForm.controls.artifact.setValue(this.artifactNameOptions[0]);
          }
          this.getReviewers(true);
        } else {
          this.sharedService.loaderHide.emit(false);
          this.dialogRef.close();
          this.notifyService.notify('warning', 'No Data', 'No successfully executed artifacts were found with associated code linkage');
        }
      }, error => {
        this.sharedService.loaderHide.emit(false);
      });
    }
  }

  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    return JSON.parse(jsonPayload);
  }

  getReviewers(isReportDataNeeded: boolean) {
    this.userService.getReviewersByProjectId(this.projectId).subscribe(data => {
      let currentUser = JSON.parse(localStorage.getItem("currentUser")).token;
      let username = this.parseJwt(JSON.stringify(currentUser)).sub;
      this.reviewerOptions = data["data"];
      this.reviewerOptions = this.reviewerOptions.filter(option => option.name !== username);
      if (isReportDataNeeded) {
        this.getReportsData();
      } else {
        this.sharedService.loaderHide.emit(false);
      }
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  getReportsData() {
    this.projectService.getCodeReviewReportsDataByProjectId(this.projectId).subscribe(data => {
      if(data["operationStatus"] != "ERROR") {
        this.reportArtifactNameOptions = data["data"]["artifacts"];
        this.allReportsData = data["data"]["reports"];
        if (this.reportArtifactNameOptions.length > 0) {
          if (this.codeReviewForm.controls.artifact.value.artifactType == "suite") {
            let reportArtifactIndex = this.reportArtifactNameOptions.findIndex(reportArtifactOption => reportArtifactOption.artifactId == this.codeReviewForm.controls.artifact.value.artifactId);
            if (reportArtifactIndex != -1) {
              this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[reportArtifactIndex]);
            } else {
              this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[0]);
            }
          } else {
            this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[0]);
          }        
          this.artifactReports = this.allReportsData.filter(artifactReport => artifactReport.artifactId == this.codeReviewForm.controls.reportArtifact.value.artifactId);
          if (this.artifactReports.length > 0) {
            this.codeReviewForm.controls.report.setValue(this.artifactReports[0]);
          }
        }        
      }
      this.sharedService.loaderHide.emit(false);
    }, error => {
      this.sharedService.loaderHide.emit(false);
    });
  }

  buildForm(): FormGroup {    
    const reviewForm: FormGroup = this.formBuilder.group({
      title: new FormControl("", Validators.required),
      description: new FormControl(""),
      artifactType: new FormControl("suite", Validators.required),      
      artifact: new FormControl("", Validators.required),
      reviewers: new FormControl([]),
      reportArtifact: new FormControl("", Validators.required),
      report: new FormControl("", Validators.required),
    })
    return reviewForm;
  }

  onSubmitAdd(): void {
    if (!this.codeReviewForm.valid) {
      this.codeReviewForm.markAllAsTouched();
      return;
    }
    this.sharedService.loaderHide.emit(true);
    this.codeReviewModel = new CodeReviewModel();
    this.codeReviewModel.artifact_id = this.codeReviewForm.controls.artifact.value.artifactId;
    this.codeReviewModel.artifact_name = this.codeReviewForm.controls.artifact.value.artifactName;
    this.codeReviewModel.artifact_type = this.codeReviewForm.controls.artifact.value.artifactType;
    this.codeReviewModel.title = this.codeReviewForm.controls.title.value;
    this.codeReviewModel.project_id = this.projectId;

    let codeReviewers: { [key: string]: CodeReviewerModel } = {};
    if (this.codeReviewForm.controls.reviewers.value.length > 0) {
      this.codeReviewForm.controls.reviewers.value.forEach((reviewer) => {
          codeReviewers[reviewer.user_id] = reviewer;
      });
    }
    this.codeReviewModel.reviewers = codeReviewers;

    let codeReviewCommentModel: CodeReviewCommentModel = null;
    if(this.codeReviewForm.controls.description.value != null && this.codeReviewForm.controls.description.value != "") {
      codeReviewCommentModel = new CodeReviewCommentModel();
      codeReviewCommentModel.body = this.codeReviewForm.controls.description.value;
    }

    this.codeReviewModel.artifact_report_id = this.codeReviewForm.controls.report.value.reportId;

    this.codeReviewService.addCodeReviewForArtifact(this.codeReviewModel, codeReviewCommentModel).subscribe(data => {
      this.sharedService.loaderHide.emit(false);
      if(data["operationStatus"] == "ERROR") {
        this.notifyService.notify('error', 'Failed', (data["operationMessage"] == 'Code Review Already Exists' || data["operationMessage"] == 'Code linkage data is not present') ? data["operationMessage"] : 'Error in Creating Code Review');
      
      } else {
        this.dialogRef.close(data["data"]);
      }
    }, error => {
      this.notifyService.notify('error', 'Failed', 'Error in Creating Code Review');
      this.sharedService.loaderHide.emit(false);
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  onArtifactTypeChange(value) {
    this.codeReviewForm.controls.artifact.setValue(null);
    this.artifactNameOptions = this.artifactsData.filter(artifact => artifact.artifactType == value);
    if (this.artifactNameOptions.length > 0) {
      this.codeReviewForm.controls.artifact.setValue(this.artifactNameOptions[0]);
    }
  }

  onArtifactChange(value) {
    if (value.artifactType == "suite") {
      let reportArtifactIndex = this.reportArtifactNameOptions.findIndex(reportArtifactOption => reportArtifactOption.artifactId == value.artifactId);
      if (reportArtifactIndex != -1) {
        this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[reportArtifactIndex]);
      } else {
        this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[0]);
      }
    } else {
      this.codeReviewForm.controls.reportArtifact.setValue(this.reportArtifactNameOptions[0]);
    }        
    this.artifactReports = this.allReportsData.filter(artifactReport => artifactReport.artifactId == this.codeReviewForm.controls.reportArtifact.value.artifactId);
    this.codeReviewForm.controls.report.setValue(null);
    if (this.artifactReports.length > 0) {
      this.codeReviewForm.controls.report.setValue(this.artifactReports[0]);
    }
  }

  onReportArtifactChange(value) { 
    this.codeReviewForm.controls.report.setValue(null);
    this.artifactReports = this.allReportsData.filter(artifactReport => artifactReport.artifactId == value.artifactId);
    if (this.artifactReports.length > 0) {
      this.codeReviewForm.controls.report.setValue(this.artifactReports[0]);
    }
  }

}
